<script>
    import PreviewElement from "./PreviewElement";
    import MediaGalleryElement from "../../components/pagesbuilder/elements/MediaGalleryElement";

    export default {
        name: "PreviewMediaGalleryElement",
        mixins: [
            PreviewElement,
            MediaGalleryElement,
        ],
        created() {
            const _this = this;
            $(`[data-fancybox="${this.fancyboxId}"]`).fancybox({
                afterLoad: function() {
                    if(_this.getShowCaptions()) {
                        const captionNode = this.element.get(0).querySelector('.js-screen-caption')
                        this.wrap.get(0)
                            .querySelector('.fancybox-inner')
                            .appendChild(captionNode.cloneNode(true));
                    }
                },
                openEffect	: 'elastic',
                closeEffect	: 'elastic',
                padding: 0,
                helpers: {
                    title: {
                        type: 'over',
                    },
                },
            });
        }
    }
</script>
